import React from "react";
import MainResult from "../../MainContent/MainResult";

const Results = () => {
  return <MainResult />;
};

export default Results;
